import React from 'react';
import langConf from "../js/lang";
import ShoppingButton from './ShoppingButton';

class CartItems extends React.Component {

    numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    render() {
        let lang = this.props.lang;
        let cart = [];
        let itemCount = 0;
        let itemSum = 0;
        let currency = this.props.currency === 'ILS' ? langConf[lang].ILS : langConf[lang].USD;

        // Insert all available items into cart
        this.props.allItems.map((item) => cart.push(
            {
                itemNo: item.itemNo,
                category: item.category,
                hebDescription: item.hebDescription,
                engDescription: item.engDescription,
                hebName: item.hebName,
                engName: item.engName,
                picDescription: item.picDescription,
                picFile: item.picFile,
                priceNis: item.priceNis,
                priceUsd: item.priceUsd,
                quantity: item.quantity,
                cartNo: item.cartNo,
                recKey: item.recKey,
                runningLineNo: item.runningLineNo,
                cartItemDate: item.cartItemDate,
                isFull: false // Waiting for API
            }
        ));

        cart.map((item) => itemCount += item.quantity);
        cart.map((item) => itemSum += this.props.currency === "ILS" ? (item.priceNis === null || item.priceNis === '' ? 0 : (item.priceNis * item.quantity)) : (item.priceUsd === null || item.priceUsd === '' ? 0 : (item.priceUsd * item.quantity)));
        let index = 0;
        const cartItems = cart.map((item) => {
            index++;
            if (item.quantity !== 0) {
                return (
                    <tr key={`${index}.  ${item.itemNo}`}>
                        <td style={{ display: 'none' }}>{item.itemNo}</td>
                        <td style={{textAlign: 'center'}} data-label={langConf[lang].itemName}>{lang === 'hebrew' ? item.hebName : item.engName}</td>
                        <td style={{textAlign: 'center'}} data-label={langConf[lang].quantity}>{item.quantity}</td>
                        <td style={{textAlign: 'center'}} data-label={langConf[lang].price}>{`${this.numberWithCommas(this.props.currency === "ILS" ? ((item.priceNis === null ? 0 : item.priceNis) * item.quantity) : ((item.priceUsd === null ? 0 : item.priceUsd) * item.quantity))} ${currency}`}</td>
                        <td>
                            <ShoppingButton
                                //Variables
                                allItems={this.props.allItems}
                                param={item.itemNo}
                                param2={-1}
                                tableView={true}
                                btnClassName={"removeFromCart"}
                                btnDir={"right"}
                                btnSize={``}
                                btnColor={"red"}
                                iconClass={"minus icon"}
                                isDisabled={item.isFull}
                                //Methods
                                onClick={this.props.removeFromCart}
                                updateItemCount={this.props.updateItemCount}
                            />
                        </td>
                    </tr>
                );
            }
            else {
                return <tr key={`${index}.  ${item.itemNo}`} style={{ display: 'none' }}></tr>
            }
        });

        return (
            <div className="col-12">
                <div className="col-12 panel panel-info" style={{ display: itemCount > 0 ? '' : 'none' }}>
                    <div className='panel-heading'>{langConf[lang].cart}</div>
                    <table className={`table table-hover table-responsive`} style={{ textAlign: langConf[lang].right, direction: 'rtl' }}>
                        <thead>
                            <tr style={{textAlign: 'center'}}>
                                <th style={{ display: 'none', textAlign: 'center' }}>{langConf[lang].itemNo}</th>
                                <th style={{textAlign: 'center'}}>{langConf[lang].itemName}</th>
                                <th style={{textAlign: 'center'}}>{langConf[lang].quantity}</th>
                                <th style={{textAlign: 'center'}}>{langConf[lang].price}</th>
                                <th style={{textAlign: 'center'}}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {cartItems}
                        </tbody>
                        <tfoot>
                            <tr>
                                <th style={{textAlign: 'center'}}>{langConf[lang].subtotal}</th>
                                <th style={{textAlign: 'center'}}>{`${itemCount} ${langConf[lang].items}`}</th>
                                <th style={{textAlign: 'center'}}>{`${this.numberWithCommas((itemSum === null ? 0 : itemSum))} ${currency}`}</th>
                                <th style={{textAlign: 'center'}}></th>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        );
    }
}

export default CartItems;
